import { Sun, Moon } from 'lucide-react';
import { usePortalConfigStore } from '@/stores/portalConfigStore';

export function DarkModeToggle() {
  const { config, isDarkMode, toggleDarkMode } = usePortalConfigStore();

  if (!config.enableDarkMode) return null;

  return (
    <button
      onClick={toggleDarkMode}
      className="flex items-center justify-center p-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition-colors"
      aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDarkMode ? 'Light mode' : 'Dark mode'}
    >
      {isDarkMode ? (
        <Sun className="h-5 w-5" />
      ) : (
        <Moon className="h-5 w-5" />
      )}
    </button>
  );
}
